import { INote } from './../../services/notes.service';
import { NotesService } from '../../services/notes.service';
import { AccountsService, EmployeesService, ContactsService } from '../../services';

export const noteState: aboTheme.IState = {
    parent: 'app',
    name: "notes",
    url: "/notes",
    component: 'noteComponent',
    redirectTo: "notes.list",
    data: {
        permissions: {
            only: ['BACKOFFICE'],
            redirectTo: 'schedule'
        }
    }
};

export const noteListState: aboTheme.IState = {
    name: "notes.list",
    url: "/list",
    resolve: {
        notes: (NotesService: NotesService) => { "ngInject"; return NotesService.all().then((notes: INote[]) => notes.filter(note => !note.applicantId)); },
        noteTags: (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('NoteTags'); }
    },
    views: {
        "main": 'noteListComponent'
    },
};

export const noteItemState = {
    name: "notes.item",
    url: "/:id",
    params: {
        "isArchive": null
    },
    resolve: {
        note: (NotesService: NotesService, $stateParams: ng.ui.IStateParamsService) => {
            "ngInject";
            if ($stateParams['id']) {
                return NotesService.get($stateParams['id']);
            }
        }
    },
    views: {
        "main": 'noteItemComponent'
    }
};

export const noteItemBasicState: aboTheme.IState = {

    name: "notes.item.basic",
    url: "/basic",
    modal: ['note'],
    resolve: {
        // users: (EmployeesService: EmployeesService) => { 'ngInject'; return EmployeesService.gatBackoffice(); },
        accounts: (AccountsService: AccountsService) => { "ngInject"; return AccountsService.all(); },
        // contacts: (ContactsService: ContactsService) => { 'ngInject'; return ContactsService.all(); }, 
        employees: (EmployeesService: EmployeesService) => { "ngInject"; return EmployeesService.getEmployeesByStatus(); },
        // noteStatuses : (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('NoteStatus'); }
    },
    component: 'noteItemBasicComponent'
};

// export const noteArchiveState: aboTheme.IState = {
//     name: "notes.archive",
//     url: "/archive",
//     resolve: {
//         notes: (NotesService: NotesService) => { "ngInject"; return NotesService.getArchive(); },
//     },
//     views: {
//         "main": 'noteArchiveComponent'
//     },
// };


// WEBPACK FOOTER //
// ./src/app/modules/notes/notes.states.ts